import * as i0 from "@angular/core";
export class TextStore {
}
TextStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TextStore_Factory() { return new TextStore(); }, token: TextStore, providedIn: "root" });
export var TextStoreKeys;
(function (TextStoreKeys) {
})(TextStoreKeys || (TextStoreKeys = {}));
